import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { HelpButton } from './HelpButton';
import { SkipLink } from './SkipLink';

/** Standart sahifalar uchun: Navbar + kontent + Footer. */
export function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SkipLink />
      <div className="sticky top-0 z-50">
        <Navbar />
      </div>
      <main id="main" tabIndex={-1} className="flex-1 outline-none">
        <Outlet />
      </main>
      <Footer />
      <HelpButton />
    </div>
  );
}

/** Solve sahifasi uchun: faqat Navbar, to'liq balandlik, footer yo'q. */
export function AppLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SkipLink />
      <Navbar />
      <main id="main" tabIndex={-1} className="min-h-0 flex-1 outline-none">
        <Outlet />
      </main>
    </div>
  );
}
